import React from 'react';
import cn from 'classnames';
import { LinearProgress, Stack } from '@mui/material';
import Box from '@mui/material/Box';

import { createSx } from '../../../../utils';
import { CONTENT_SIZES } from '../../consts';

const sx = createSx({
  root: {
    width: '100%',
    backgroundColor: 'neutral.surfaceBright',
    borderTop: '1px solid',
    borderColor: 'neutral.outlineVariant',
  },
  content: {
    height: 72,
    width: {
      xs: '100%',
      lg: CONTENT_SIZES.WIDTH,
    },
    px: {
      xs: 2,
      lg: 0,
    },
    boxSizing: 'border-box',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&.fullWidth': {
      flex: 1,
      width: 'unset',
      px: 3
    }
  },
  sideContent: {
    display: 'flex',
    alignItems: 'center',
  },
});

interface Props {
  left?: React.ReactNode;
  right?: React.ReactNode;
  children?: React.ReactNode;
  loading?: boolean;
  fullWidth?: boolean;
}

const PageFooter = ({ left, right, loading, fullWidth, children }: Props) => {
  return (
    <Box component='footer' sx={sx.root} >
      {loading && <LinearProgress />}
      <Box sx={sx.content} className={cn(fullWidth && 'fullWidth')}>
        <Stack direction='row' spacing={2} sx={sx.sideContent}>
          {left}
        </Stack>
        {children}
        <Stack direction='row' spacing={2} sx={sx.sideContent}>
          {right}
        </Stack>
      </Box>
    </Box>
  );
};

export default PageFooter;